import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import poReducer from './poSlice';
import invoiceReducer from './invoiceSlice';
import notificationReducer from './notificationSlice';
import userReducer from './userSlice';
import companyReducer from './companySlice';
import activityReducer from './activitySlice';
import dashboardReducer from './dashboardSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    purchaseOrders: poReducer,
    invoices: invoiceReducer,
    notifications: notificationReducer,
    users: userReducer,
    companies: companyReducer,
    activities: activityReducer,
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;